import React from "react";
import { BRAND } from "@/data";
import { EN } from "@/en";

export default function Legal({ type, lang = "fr" }) {
  const isPrivacy = type === "privacy";
  if (lang === "en") {
    return (
      <div data-testid={`page-legal-${type}-en`} className="py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <h1 className="font-serif text-4xl lg:text-5xl font-light text-forest">
            {isPrivacy ? EN.privacy.title : EN.legal.title}
          </h1>
          <div className="prose prose-neutral mt-8 text-charcoal/70 leading-relaxed space-y-4">
            {isPrivacy ? (
              <>
                {EN.privacy.p.map((para, i) => <p key={i}>{para}</p>)}
                <p>{EN.privacy.contactSuffix} {BRAND.email}.</p>
              </>
            ) : (
              <>
                <p><strong>{EN.legal.editor}</strong> {EN.legal.editorValue}</p>
                <p><strong>{EN.legal.contact}</strong> {BRAND.phone} — {BRAND.email}</p>
                <p>{EN.legal.content}</p>
                <p>{EN.legal.booking}</p>
                <p><strong>{EN.legal.creditsLabel}</strong> — {EN.legal.credits}</p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div data-testid={`page-legal-${type}`} className="py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <h1 className="font-serif text-4xl lg:text-5xl font-light text-forest">
          {isPrivacy ? "Politique de confidentialité" : "Mentions légales"}
        </h1>
        <div className="prose prose-neutral mt-8 text-charcoal/70 leading-relaxed space-y-4">
          {isPrivacy ? (
            <>
              <p>Ce site ne comporte aucun formulaire de collecte. Les prises de contact se font directement par téléphone ou par email auprès d'Anne.</p>
              <p>Des données techniques (adresse IP, journaux de connexion, cookie de sécurité « cf_clearance ») peuvent être traitées par l'hébergeur à des fins de fonctionnement et de sécurité. Le site charge des polices de caractères via Google Fonts, ce qui peut transmettre votre adresse IP à Google. Les liens vers Booking, les cartes et les sites touristiques renvoient vers des services tiers qui appliquent leurs propres politiques de confidentialité.</p>
              <p>Les informations que vous transmettez volontairement par email ou par téléphone sont utilisées uniquement pour répondre à votre demande de séjour et ne sont ni revendues ni partagées. Pour toute question relative à vos données, contactez-nous à l'adresse {BRAND.email}.</p>
            </>
          ) : (
            <>
              <p><strong>Éditeur du site :</strong> {BRAND.name} — Chez Anne · Au 19, Tanlay (Bourgogne).</p>
              <p><strong>Contact :</strong> {BRAND.phone} — {BRAND.email}</p>
              <p>Photographies et contenus des hébergements : Anne Yvois – Le Point de Vue de Tanlay. Tous droits réservés. Les visuels de la section « Découvrir la Bourgogne » sont des visuels d'ambiance.</p>
              <p>Les réservations peuvent être effectuées directement auprès d'Anne Yvois ou via Booking.</p>
              <p><strong>Crédits photographiques</strong> — Section « Découvrir la Bourgogne » : château de Tanlay © Myrabella / Wikimedia Commons (CC BY-SA 4.0) ; château d'Ancy-le-Franc © Zairon / Wikimedia Commons (CC BY-SA 4.0).</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
